import React from 'react';
import { useData, useField, reportTimeOfDay, reportWallClock } from '../EpcrDataContext';
import { Icons } from '../EpcrIcons';
import { Section, ViewLayout } from '../EpcrFields';

export function EpcrViewAssessments() {
  const data = useData();
  const vitals = useField("eVitals/eVitals.VitalGroup") || [];
  const list = Array.isArray(vitals) ? vitals : [];
  const sorted = [...list].sort((a, b) => (a["eVitals.01"] || "").localeCompare(b["eVitals.01"] || ""));

  const sections = sorted.map((v, i) => ({
    id: `assess-${i + 1}`,
    label: `Assessment ${i + 1} — ${fmt(v["eVitals.01"])}`,
  }));

  function fmtDate(iso) {
    const [y, m, d] = reportWallClock(iso).slice(0, 10).split('-');
    return d ? `${Number(m)}/${Number(d)}/${y}` : "—";
  }

  function fmt(iso) {
    return reportTimeOfDay(iso, false);
  }

  return (
    <ViewLayout sections={sections}>
      <div className="assess-list">
        {sorted.map((v, i) => {
          const g = v["eVitals.GlasgowScoreGroup"] || {};
          const bpg = v["eVitals.BloodPressureGroup"] || {};
          const hrg = v["eVitals.HeartRateGroup"] || {};
          const cg = v["eVitals.CardiacRhythmGroup"] || {};
          const tmp = v["eVitals.TemperatureGroup"] || {};
          return (
            <div className="assess-card" id={`assess-${i + 1}`} data-section={`assess-${i + 1}`} key={i} style={{ scrollMarginTop: 120 }}>
              <div className="assess-head">
                <Icons.clipboard size={16} />
                <span className="t">{fmt(v["eVitals.01"])} · {fmtDate(v["eVitals.01"])}</span>
                <span className="who">{data.label("eVitals.02", v["eVitals.02"]) || ""}</span>
                <span className="ai">Assessment #{i + 1}</span>
              </div>
              <div className="assess-grid">
                <Row k="GCS Eye" v={g["eVitals.19"]} />
                <Row k="GCS Verbal" v={g["eVitals.20"]} />
                <Row k="GCS Motor" v={g["eVitals.21"]} />
                <Row k="GCS Total" v={g["eVitals.23"]} flag={g["eVitals.23"] && g["eVitals.23"] < 13 ? "abnormal" : "normal"} />
                <Row k="GCS Qual" v={data.label("eVitals.22", g["eVitals.22"])} />
                <Row k="BP" v={bpg["eVitals.06"] && bpg["eVitals.07"] ? `${bpg["eVitals.06"]}/${bpg["eVitals.07"]}` : ""} />
                <Row k="MAP" v={bpg["eVitals.09"]} />
                <Row k="HR" v={hrg["eVitals.10"]} />
                <Row k="SpO₂" v={v["eVitals.12"] ? `${v["eVitals.12"]}%` : ""} />
                <Row k="RR" v={v["eVitals.14"]} />
                <Row k="Temp" v={tmp["eVitals.24"] ? `${tmp["eVitals.24"]}°C` : ""} />
                <Row k="Glucose" v={v["eVitals.18"] ? `${v["eVitals.18"]} mg/dL` : ""} flag={v["eVitals.18"] && v["eVitals.18"] < 70 ? "abnormal" : (v["eVitals.18"] ? "normal" : "")} />
                <Row k="Stroke (CPSS)" v={v["eVitals.33"]} />
                <Row k="Cardiac rhythm" v={data.label("eVitals.04", cg["eVitals.04"])} />
                <Row k="Skin assessment" v={data.label("eVitals.26", v["eVitals.26"])} />
                <Row k="Level of responsiveness" v={data.label("eVitals.AVPU", v["eVitals.26"])} />
              </div>
            </div>
          );
        })}
        {sorted.length === 0 && (
          <div style={{ padding: 40, textAlign: "center", color: "var(--epcr-ink-4)", border: "1px dashed var(--epcr-line)", borderRadius: 8 }}>
            No assessments recorded
          </div>
        )}
      </div>

      <div className="add-bar">
        <button className="btn-primary"><Icons.plus size={14} /> Add assessment</button>
        <button className="btn-secondary"><Icons.note size={14} /> Use template</button>
      </div>
    </ViewLayout>
  );
}

function Row({ k, v, flag }) {
  const empty = v == null || v === "";
  return (
    <div className={"row " + (flag || "")}>
      <span className="k">{k}</span>
      <span className="v" style={empty ? { color: "var(--epcr-ink-4)" } : null}>{empty ? "—" : v}</span>
    </div>
  );
}
